import { BaseModel } from './base.model';

export interface Type {
    id: number;
    name: string;
    description: string;
    category: string;
  }

export class Type implements BaseModel {
  id: number;
  name: string;
  description: string;
  category: string;

  constructor();
  constructor(id: number, name: string, description: string, category: string);

  constructor(id?: number, name?: string, description?: string, category?: string) {
    if (id !== undefined) {
      this.id = id;
    }

    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (description !== undefined) {
      this.description = description;
    } else {
      this.description = '';
    }

    if (category !== undefined) {
      this.category = category;
    } else {
      this.category = '';
    }
  }

  getApiName(): string {
    return 'types';
  }

  getName(): string {
    return 'Tipo';
  }

  getNamePl(): string {
    return 'Tipos';
  }
}
  